export default {
    financiers: [],
    financierId: null
};
